export default "__VITE_ASSET__C$YJUjMZ__"